import TextMaskHoc from './textMask';

export const CreditCardMask = TextMaskHoc(
  [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
  '4242 4242 4242 4242'
);

export const CvvMask = TextMaskHoc([/\d/, /\d/, /\d/], '111');
export const ExpMask = TextMaskHoc([/\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/], 'MM/YYYY');
export const ZipCodeMask = TextMaskHoc([/\d/, /\d/, /\d/, /\d/, /\d/], '12345');
